import {gql} from '@apollo/client';

import {ErrorFragment} from 'graphql-client/Error';

export const SOLVENT_LIBRARY_QUERY = gql`
  query SolventLibraryQuery @skipAudit @engComponent(name: CHEMISTRY) {
    solvents {
      id
      name
      code
      canonicalSmiles
      archiveData {
        archived
        purpose
      }
      imageData {
        ... on SVGNode {
          base64Svg
        }
        ...Error
      }
    }
  }
  ${ErrorFragment.fragment}
`;
